export default [
    // *===============================================---*
    // *--------- Equipments  ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/elearning/elearning-list',
        name: 'elearning-list',
        component: () => import('@/views/elearning/Elearning.vue'),
        meta: {
            pageTitle: 'Setup / Users',
            breadcrumb: [
                {
                    text: 'E-learning',
                    active: true,
                },
            ],
            //permission: 'Permissions.Inventory.View'  
        },
    },
]